exports.APIS = {
  Auth: "/common/auth/login",

  Dashboard: "/admin/dashboard/dashboard-data",
  DashboardAnalytics: "/admin/dashboard/analytics",
  Download: "/admin/dashboard/download",

  Masters: {
    Country: "/admin/masters/country",
    State: "/admin/masters/state",
    City: "/admin/masters/city",
    Pincode: "/admin/masters/pincode",
    App_Setup: "/admin/masters/app-setup",
    HomeBanner: "/admin/masters/home-banners",
    Courses: "/admin/masters/courses",
    SchoolBoard: "/admin/masters/school-boards",
    Reviews: "/admin/masters/reviews",
    Policies: "/admin/policies",
  },

  Subscriptions: {
    SFeatures: "/admin/subscriptions/s-features",
    SSubscription: "/admin/subscriptions/s-subscription",
    RSubscription: "/admin/subscriptions/r-subscription",
  },
  Subscription_History: {
    Student_Subscription: "/admin/subscription-histories/student",
    Recruiter: "/admin/subscription-histories/recruiter",
    Recruiter_Subscription:
      "/admin/subscription-histories/recruiter-subscription",
  },

  // common
  Commons: {
    AllRoles: "/common/masters/all-roles",
    AllPermmission: "/common/masters/all-permission",
    Country: "/common/masters/all-country",
    State: "/common/masters/all-state",
    City: "/common/masters/all-city",
    Pincode: "/common/masters/all-pincode",
    Locations: "/common/thired-party/places",
    TicketStatus: "/common/masters/all-ticket-status",
    University: "/common/masters/all-university",
    StudentSubFeature: "/common/masters/all-s-features",
    BillingType: "/common/masters/all-billing-type",
    UniversityCampus: "/common/masters/all-university-campus",
    Gender: "/common/masters/all-gender",
    EducationType: "/common/masters/all-education-type",
    Streams: "/common/masters/all-streams",
    Degrees: "/common/masters/all-degrees",
    Departments: "/common/masters/all-departments",
    Courses: "/common/masters/all-course",
    PerformanceScale: "/common/masters/all-performance-scales",
    Skills: "/common/masters/all-skills",
    Language: "/common/masters/all-language",
    StudentStatus: "/common/masters/all-student-status",
    JobType: "/common/masters/all-job-type",
    WorkplaceType: "/common/masters/all-workplace-types",
    CompanyType: "/common/masters/all-company-type",
    CompanySize: "/common/masters/all-company-size",
    ConsultancyType: "/common/masters/all-consultancy-type",
    Industry: "/common/masters/all-industry",
    RSubscription: "/common/masters/all-r-subscription",
    SSubscription: "/common/masters/all-s-subscription",
    BulkAdminStudentSample: "/common/masters/bulk-admin-student-sample",
  },

  UserManagement: {
    Roles: "/admin/roles",
    Employees: "/admin/roles/employees",
    Owner: "/admin/customer-management/customer",
  },

  Policy: {
    Policy: "/admin/policy/policy",
    FollowUs: "/admin/policy/follow-us",
    AboutUs: "/admin/policy/about-us",
  },

  NotificationsManagement: {
    Notifications: "/admin/notifications/notifications",
  },
  UniversityManagement: {
    University: "/admin/university/university",
    Campus: "/admin/university/campus",
  },

  SupportManagement: {
    RHelpSupports: "/admin/support-management/r-help-support",
    ContactUs: "/admin/support-management/contact-us",
    Feedbacks: "/admin/support-management/feedbacks",
    RecruiterTickets: "/admin/support-management/recruiter-tickets",
    RecruiterTicketsCounts:
      "/admin/support-management/recruiter-tickets-counts",
  },

  StudentManagement: {
    Students: "/admin/students",
    Details: "/admin/students/details",
    BulkFormat2: "/admin/students/bulk-format2",
  },

  RecruiterManagement: {
    Recruiters: "/admin/recruiters",
  },
};
